var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 824.2 824.201",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M824.2,715.7V216.3c-22.8,26.4-57.3,50.3-102.3,70.4c-73.2,32.7-167.5,52.4-268.801,56.6v24.3c0,13.8-11.199,25-25,25h-32 c-13.8,0-25-11.2-25-25v-24.2c-101.399-4.2-195.6-23.9-268.8-56.6c-45-20.1-79.5-44-102.3-70.4v499.4c0,13.8,11.2,25,25,25h774.3 C813,740.7,824.2,729.5,824.2,715.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.7,83.4H309.3c-41.399,0-75,33.6-75,75v28.1H14.6c3.6,5.1,7.8,10.2,12.6,15.3c20.3,21.4,49.6,40.8,87.3,57.6 c79.2,35.4,184.9,54.9,297.6,54.9c112.7,0,218.301-19.5,297.601-54.9c37.6-16.8,67-36.2,87.3-57.6c4.8-5,9-10.1,12.6-15.3H589.7 v-28.1C589.7,117.1,556.1,83.4,514.7,83.4z M284.3,186.5v-28.1c0-13.8,11.2-25,25-25h205.4c13.8,0,25,11.2,25,25v28.1H284.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.067d48d4a2197119f5c73f60e6d03c4e.svg";
export { ForwardRef as ReactComponent };